import FileSaver from "file-saver";
import * as domToImage from "dom-to-image";

export function exportBlob(filename: string, data: Blob) {
  FileSaver.saveAs(data, filename + getFileExt(data));
}

export async function exportHtmlElement(filename: string, el: HTMLElement) {
  const content = await domToImage.default.toBlob(el, { bgcolor: "#FFFFFF" });
  exportBlob(filename, content);
}

export function exportBase64(filename: string, mimeType: string, base64Data: string) {
  const data = base64toBlob(base64Data, mimeType);
  exportBlob(filename, data);
}

function getFileExt(content: Blob): string {
  switch (content.type) {
    case "application/pdf":
      return ".pdf";
    case "application/vnd.ms-excel":
      return ".xlsx";
    case "image/png":
      return ".png";
    case "image/jpeg":
      return ".jpg";
    default:
      return ".txt";
  }
}

export function base64toBlob(b64Data: string, contentType = "", sliceSize = 512): Blob {
  const byteCharacters = atob(b64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
}

export async function readDataURL(file: File): Promise<string | ArrayBuffer | null> {
  const reader = new FileReader();
  const promise = new Promise<string | ArrayBuffer | null>((resolve, reject) => {
    reader.onload = function () {
      resolve(reader.result);
    };
    reader.onerror = function (error) {
      reject(error);
    };
  });
  reader.readAsDataURL(file);
  return promise;
}
